import { useState } from 'react';
import { sourceColors, segmentColors, type Lead } from '../../../mocks/leads';

interface LansmanaKatilanlarProps {
  leads: Lead[];
  onViewDetail: (lead: Lead) => void;
}

export default function LansmanaKatilanlar({ leads, onViewDetail }: LansmanaKatilanlarProps) {
  const [sentIds, setSentIds] = useState<Set<string>>(new Set());
  const [search, setSearch] = useState('');

  const filteredLeads = leads
    .filter((l) => l.lansmanKatilim === true || l.lansman_katilim_durumu === 'Katılmak İstiyor' || l.lansman_katilim_durumu === 'Katılacak' || l.lansman_katilim_durumu === 'Davet Gönderildi')
    .filter((l) =>
      search
        ? l.ad_soyad.toLowerCase().includes(search.toLowerCase()) || l.telefon.includes(search)
        : true
    );

  function sendInvite(lead: Lead) {
    setSentIds((prev) => new Set([...prev, lead.id]));
    const phone = lead.telefon.replace(/\D/g, '');
    const msg = encodeURIComponent(
      `Merhaba ${lead.ad_soyad}, franchise lansmanımıza katılımınızı onayladınız. Sizi bekliyoruz!`
    );
    window.open(`https://wa.me/${phone}?text=${msg}`, '_blank');
  }

  return (
    <div className="space-y-5">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-xl font-bold text-white">Lansmana Katılmak İsteyenler</h1>
          <p className="text-white/30 text-sm mt-0.5">{filteredLeads.length} kişi katılım talebi oluşturdu</p>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-xs text-emerald-400 font-semibold px-3 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/20">
            <i className="ri-rocket-2-line mr-1" />
            {filteredLeads.length} Katılımcı
          </span>
        </div>
      </div>

      <div className="relative max-w-sm">
        <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-white/30 text-sm" />
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="İsim veya telefon ara..."
          className="w-full bg-white/[0.04] border border-white/[0.08] rounded-lg pl-9 pr-4 py-2.5 text-white text-sm placeholder:text-white/20 focus:outline-none focus:border-amber-500/50"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredLeads.map((lead) => {
          const isSent = sentIds.has(lead.id) || lead.davetGonderildi;
          return (
            <div
              key={lead.id}
              className="rounded-xl bg-white/[0.03] border border-white/[0.07] p-5 space-y-4 hover:border-white/[0.12] transition-all"
            >
              <div className="flex items-start justify-between">
                <div>
                  <p className="text-white font-semibold text-sm">{lead.ad_soyad}</p>
                  <p className="text-white/30 text-xs font-mono mt-0.5">{lead.telefon}</p>
                </div>
                <span
                  className="text-[10px] font-bold px-2 py-0.5 rounded-full"
                  style={{
                    background: (sourceColors[lead.kaynak] || '#6b7280') + '22',
                    color: sourceColors[lead.kaynak] || '#6b7280',
                  }}
                >
                  {lead.kaynak}
                </span>
              </div>

              <div className="flex items-center gap-2">
                <span
                  className="text-[10px] font-bold px-2 py-0.5 rounded-full"
                  style={{
                    background: (segmentColors[lead.segment_durum] || '#6b7280') + '22',
                    color: segmentColors[lead.segment_durum] || '#6b7280',
                  }}
                >
                  {lead.segment_durum}
                </span>
                <span className="text-white/30 text-[10px]">{lead.is_seviyesi}</span>
              </div>

              <div className="flex gap-2">
                <button
                  onClick={() => sendInvite(lead)}
                  className={`flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold transition-all cursor-pointer ${
                    isSent
                      ? 'bg-emerald-500/15 text-emerald-400 border border-emerald-500/20'
                      : 'bg-[#25d366]/15 hover:bg-[#25d366]/25 text-[#25d366]'
                  }`}
                >
                  <i className={isSent ? 'ri-check-line' : 'ri-whatsapp-line'} />
                  {isSent ? 'Gönderildi' : 'Davet Gönder'}
                </button>
                <button
                  onClick={() => onViewDetail(lead)}
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/[0.05] hover:bg-amber-500/15 text-white/30 hover:text-amber-400 transition-all cursor-pointer"
                >
                  <i className="ri-eye-line text-sm" />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}